$('.btn-moonboard').on('click', function () {
    if ($(window).width() >= 992) {
        var cart = $('.moodboard-cart');
        var imgtodrag = $('.image-single-product,.swiper-slide-inner').find("img").eq(0);
    } else {
        var cart = $('.moodboard-cart.mobile');
        var imgtodrag = $('.image-single-product,.swiper-slide-inner').find("img").eq(0);
    }
    let checkClass = this.className;
    let test = checkClass.includes('added');
    if (imgtodrag.length && cart.length && !test) { 
        var imgclone = imgtodrag.clone()
            .offset({
                top: imgtodrag.offset().top,
                left: imgtodrag.offset().left
            })
            .css({
                'opacity': '0.5',
                'position': 'absolute',
                'height': '150px',
                'width': '150px',
                'z-index': '99'
            })
            .appendTo($('body'))
            .animate({
                'top': cart.offset().top + 10,
                'left': cart.offset().left + 10,
                'width': 75,
                'height': 75
            }, 1000, 'swing'); 
        
        setTimeout(function () {
            cart.effect("shake", {
                times: 2
            }, 200);
        }, 1500);

        imgclone.animate({
            'width': 0,
            'height': 0
        }, function () {
            $(this).detach();
        });
    } else {
        if (!imgtodrag.length) {
            console.log('Image element not found');
        }
        if (!cart.length) {
            console.log('Cart element not found');
        }
    }
    this.classList.add('added');
});
